import styled from 'styled-components';
import { Button, Checkbox, Typography, Table, Tag, Space } from 'antd';

const { Paragraph, Text } = Typography;

export const SaveButton = styled(Button)`
  margin-left: 20%;
  margin-top: 16px;
`;

export const StyledParagraph = styled(Paragraph)`
  margin-left: 20%;
  margin-bottom: 50px;
`;

export const StyledTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 7px; /* margin works now */
`;

export const StyledCheckboxGroup = styled(Checkbox.Group)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 20%;
`;

export const AdminErrorDiv = styled.div`
  color: red;
  padding: 12px;
`;

export const HistoryTable = styled(Table)`
  margin-top: 20;
`;

export const SessionTags = styled(Tag)`
  margin: 0;
  padding: 4px 8px;
  font-size: 14px;
  background: #e6f4ff;
  border-color: #e6f4ff;
`;

export const SessionTagSpace = styled(Space)`
  background: white;
  padding: 4;
`;

export const SessionText = styled(Text)`
  display: block;
  margin-top: 4px;
  margin-left: 12px;
`;

export const SsdSelectWrapper = styled.div`
  margin-left: 20%;
  margin-bottom: 16px;
`;
